export default {
  server: {
    server_name: "区服",
    player_name: "角色",
    nobind: "未绑定",
  },
  pop: {
    pleaseIn: "请填写",
    pleaseSelect: "请选择",
    phone: "请填写手机号码",
    gnjoy: "请填写GNJOY账号",
    onlineNo: "请填写RO Online游戏账号",
    onlineServe: "请选择RO Online区服",
    twilightServe: "请选择RO Twilight区服",
    twilightRole: "请填写RO Twilight角色",
    tips1: "*绑定RO Online账号且完成页面指定任务，即可获得以上奖励",
    tips2:
      "*若不绑定RO Online账号，则自动视为放弃RO Online奖励，但不影响领取《RO Twilight》奖励",
    //
    pleaseLogin: "请先登录",
    changeSuccess: "更绑成功",
    giftSuccess: "礼包发放成功",
    phoneBlock: "手机号码不能为空",
    correctPhone: "请输入正确的手机号码",
    selectServe: "请选择服务器",
  },
};
